import { Paging } from "../paging/paging"
import { Tieup } from "./Tieup"
import { getTieupList } from "../../api/v1/tieup/list/get"
import { TieupListGetInputModel } from "../../api/v1/tieup/list/GetInputModel"
import { adaptTieup } from "./adaptTieup"

type Params = {
  limit?: number
  offset?: number
}

export const fetchTieups = ({
  limit,
  offset,
}: Params): Promise<Paging<Tieup>> => {
  return getTieupList(
    new TieupListGetInputModel({
      limit,
      offset,
    }),
  ).then((res) => {
    return {
      total: res.count,
      items: res.results.map(adaptTieup),
    }
  })
}
